import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Avatar from "@mui/material/Avatar";
import appConfig from "../utils/config";
import { useDomainConfig } from "../utils/domainConfigProvider";
import AppConfig from "../utils/config";

function AppHeader() {
  const { domainConfig } = useDomainConfig();
  const isTestDomain = domainConfig?.brandUrl === AppConfig?.CustomeUI?.BrandURL;
  const isNuvah = domainConfig?.brandUrl === AppConfig?.CustomeUI?.NuvahURL;

  return (
    <AppBar
      elevation={0}
      position="static"
      sx={{
        backgroundColor: domainConfig?.bannerBgColor ? domainConfig?.bannerBgColor : '#124d6f',
        // let the scaled Nuvah logo overflow the bar without clipping
        overflow: isNuvah ? 'visible' : undefined,
      }}
    >
      <Toolbar sx={{ overflow: isNuvah ? 'visible' : undefined }}>
        <Avatar
          sx={{
            // keep the original 50x100 layout box so the blue bar height is unchanged...
            height: 50,
            width: 100,
            borderRadius: 0,
            margin: isTestDomain ? 'auto' : 'inherit',
            // ...and enlarge the logo purely visually (no effect on bar height)
            ...(isNuvah && {
              transform: 'scale(2.6)',
              transformOrigin: 'left center',
            }),
            "& img": {
              objectFit: "contain",
            },
          }}
          alt="Prozo Logo" 
          src={domainConfig !== null && domainConfig?.logoUrl ? domainConfig?.logoUrl : appConfig?.Header?.logo}
        />
      </Toolbar>
    </AppBar>
  );
}

export default AppHeader;
